<template>
    <div class="exam-camera">
        <div class="camera-container">
            <video id="exam-capture-video" autoplay loop muted></video>
            <canvas id="exam-capture-canvas" style='display: none'></canvas>
        </div>

        <div class="camera-tips">
            <h3 class="title-main">实时监控中</h3>
            <p class="title-sub">请勿遮挡脸部，保持正脸在摄像头拍摄范围内</p>
        </div>
    </div>
</template>

<script>
/**
 * todo:
 * 动态判断摄像头状态
 */

export default {
    name: 'ExamCamera',

    props: {
        data: Object,
    },

    data() {
        return {
            videoStream: null,    // 视频流
            videoSuccess: null,   // 摄像头开启状态
            errorText: ''
        }
    },

    computed: {

    },

    watch: {
        videoSuccess(v) {
            this.$emit('status-change', v, this.errorText)
        }
    },

    mounted() {
        this.initContext()

        this.showCamera().then(() => {
            this.videoSuccess = true
            this.takePhoto()

            if (this.data.photoDuration) {
                this.startPhotoLoop()
            }
        }).catch(err => {
            this.videoSuccess = false
            this.handleCameraError(err)
        })
    },

    beforeDestroy() {
        this.videoStream && this.videoStream.stop()
        this.photoInterval && clearInterval(this.photoInterval)
    },

    methods: {
        // 初始化canvas
        initContext() {
            this.canvas = document.getElementById('exam-capture-canvas')
            this.video = document.getElementById('exam-capture-video')
            this.canvas.width = this.video.clientWidth
            this.canvas.height = this.video.clientHeight
            this.context = this.canvas.getContext('2d');
        },

        // 开启摄像头
        showCamera() {
            const constraints = {
                video: {width: 800, height: 600},
                audio: false
            }

            return new Promise((resolve, reject) => {
                navigator.mediaDevices.getUserMedia(constraints)
                    .then((mediaStream) => {
                        this.videoStream = mediaStream.getTracks()[0]

                        this.video.srcObject = mediaStream
                        this.video.onloadedmetadata = (e) => {
                            this.video.play()
                            resolve(this.videoStream)
                        };

                        this.video.onerror = (e) => {
                            console.log(e)
                        }
                    })
                    .catch(err => {
                        reject(err)
                    });
            })
        },

        startPhotoLoop() {
            this.photoInterval && clearInterval(this.photoInterval)

            const duration = this.data.photoDuration * 1000

            this.photoInterval = setInterval(() => {
                // 检测流是否正常 => 中途断流
                if (this.videoStream.readyState === 'ended') {
                    this.videoSuccess = false
                    this.errorText = '用户已关闭摄像头'
                }

                // 流正常则拍照
                if (this.videoSuccess) {
                    this.takePhoto()
                }
            }, duration)
        },

        // 拍照
        takePhoto() {
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
            this.uploadPhoto()
        },

        uploadPhoto() {
            this.canvas.toBlob((blob) => {
                let formData = new FormData()
                formData.append('file', blob)
                formData.append('testId', this.data.testID)

                this.$api.uploadInvigilate(formData)
            })
        },

        handleCameraError(err) {
            const {name, message} = err
            console.log(name + ": " + message)
            const title = '摄像头开启失败'

            const notify = (msg) => {
                return this.$notify.error({
                    title,
                    message: msg,
                    duration: 0,
                    position: 'top-left'
                });
            }

            switch (name) {
                case 'NotAllowedError':
                    this.errorText = '用户已拒绝网页使用摄像头，请开启摄像头权限'
                    break
                case 'NotFoundError':
                    this.errorText = '未发现摄像头设备'
                    break
                case 'NotReadableError':
                    this.errorText = '摄像头被其他应用占用'
                    break
                default:
                    this.errorText = '摄像头开启失败'
                    break
            }
        }
    },
}
</script>

<style scoped lang="scss">
.exam-camera {
    margin-bottom: 15px;
}

.camera-container {
    position: relative;
    background-color: #000;
    font-size: 0;
}

#exam-capture-video {
    width: var(--aside-width);
    height: calc(var(--aside-width)/4*3);
}

.camera-tips {
    padding: 15px 20px;
    color: #fff;
    background-color: #3A3E51;

    .title-main {
        font-size: 14px;
    }

    .title-sub {
        margin-top: 10px;
        font-size: 12px;
    }

    @include media-1366 {
        padding: 5px 10px;
        .title-main {
            font-size: 12px;
        }
        .title-sub {
            margin-top: 4px;
        }
    }
}

.camera-avoid-container {
    background-color: #3A3E51;
    color: #fff;
}
</style>
